import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  goTo8,
  goToSemiFinal,
  goToFinal,
  goToResult,
  setWinner,
} from "../features/teamSlice";
import { getFlagUrl } from "../features/getFlagUrl";
import { ReactComponent as FacebookLargeIcon } from "../assets/icons/facebook_icon.svg";
import { ReactComponent as WhatsappLargeIcon } from "../assets/icons/whatsapp_icon.svg";
import { ReactComponent as TwitterLargeIcon } from "../assets/icons/twitter_icon.svg";
import selectedIcon from "../assets/selected.png";
import unSelectedIcon from "../assets/unselected.png";

function KnockOut() {
  const gameStep = useSelector((state) => state.team.step);
  const knockoutMatches = useSelector(
    (state) => state.team.knockoutStageMatches
  );
  const dispatch = useDispatch();
  const [showWarning, setShowWarning] = useState(false);
  // const [lazyImgLoad, setLazyImgLoad] = useState(false);
  const checkAllMatchSelected = () => {
    let output = true;
    for (let i = 0; i < knockoutMatches.length; i++) {
      output &= knockoutMatches[i][0].winner || knockoutMatches[i][1].winner;
    }
    return output;
  };
  const getChampion = () => {
    return knockoutMatches[0][0].winner
      ? knockoutMatches[0][0].nation
      : knockoutMatches[0][1].nation;
  };
  const nextStep = () => {
    if (checkAllMatchSelected()) {
      if (gameStep.knockOut16) {
        dispatch(goTo8());
      } else if (gameStep.knockOut8) {
        dispatch(goToSemiFinal());
      } else if (gameStep.semiFinal) {
        dispatch(goToFinal());
      } else if (gameStep.final) {
        dispatch(goToResult());
      }
    } else {
      setShowWarning(true);
    }
  };
  // const getCurrentStep = () => {
  //   if (gameStep.knockOut16) {
  //     return "knockOut16";
  //   } else if (gameStep.knockOut8) {
  //     return "knockOut8";
  //   } else if (gameStep.semiFinal) {
  //     return "semiFinal";
  //   } else if (gameStep.final) {
  //     return "final";
  //   }
  // };
  const social_icons = [
    <FacebookLargeIcon />,
    <WhatsappLargeIcon />,
    <TwitterLargeIcon />,
  ];
  return (
    <>
      {gameStep.result ? (
        <section className="my-3 px-2">
          {/* {getVideoFlagUrl(getChampion()).slice(-1) === "4" ? (
            <section className="mb-3 text-center">
              <div
                className="mx-auto"
                style={{ width: "300px", height: "200px" }}
              >
                <video
                  src={getVideoFlagUrl(getChampion())}
                  autoPlay
                  loop
                  playsInline
                  style={{ width: "100%", height: "100%" }}
                ></video>
              </div>
            </section>
          ) : (
            <section className="mb-3 text-center">
              <span
                className={
                  "lazy-load-image-background blur " +
                  (lazyImgLoad ? "lazy-load-image-loaded" : "")
                }
                style={{ color: "transparent", display: "inline-block" }}
              >
                <img
                  className="mt-3 img-fluid"
                  src={getVideoFlagUrl(getChampion())}
                  alt={getChampion()}
                  onLoad={() => setLazyImgLoad(true)}
                />
              </span>
            </section>
          )} */}
          <section className="text-center my-2">
            <img
              className="mb-2"
              src={getFlagUrl(getChampion())}
              alt={getChampion()}
            />
            <h4 className="mb-0 px-3 px-md-0 champion-team-name text-uppercase">
              {"¡" + getChampion() + " Campeón!"}
            </h4>
          </section>
          <section className="d-flex align-items-center justify-content-center flex-row w-50 mx-auto my-2 my-md-4">
            {social_icons.map((social_icon, social_index) => {
              return (
                <button
                  key={`social_icon` + social_index}
                  className="social-share-btn m-1 m-md-2"
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    padding: "0px",
                    font: "inherit",
                    color: "inherit",
                    cursor: "pointer",
                    height: "34px",
                    width: "34px",
                  }}
                  onClick={() => {
                    if (social_index === 0) {
                      window.open(
                        "http://www.facebook.com/dialog/share?app_id=638913950971377&display=popup&title=Según mis cálculos " +
                          getChampion() +
                          " va a ganar el mundial ¿Y para vos?&href=http://calculator.em.uy"
                      );
                    } else if (social_index === 1) {
                      window.open(
                        "whatsapp://send?text=Según mis cálculos " +
                          getChampion() +
                          " va a ganar el mundial ¿Y para vos? http://calculator.em.uy/"
                      );
                    } else {
                      window.open(
                        "https://twitter.com/share?url=http://calculator.em.uy/&text=Según mis cálculos " +
                          getChampion() +
                          " va a ganar el mundial ¿Y para vos?"
                      );
                    }
                  }}
                >
                  <a
                    className="w-100 h-100 d-flex align-items-center"
                    href="/#"
                  >
                    {social_icon}
                  </a>
                </button>
              );
            })}
          </section>
        </section>
      ) : (
        <section className="my-3 px-0">
          <section className="text-center">
            <p className="mb-0 px-3 px-md-0 team-name">
              Dale click a los equipos que crees que pasarán a cuartos del final
            </p>
          </section>
          <section className="d-flex justify-content-center flex-column flex-md-row w-50 mx-auto my-1 my-md-3">
            <article className="d-flex justify-content-center my-1 text-center">
              <span
                className={
                  "rounded mx-1 px-3 py-2 shadow text-white btn-knockout-stage " +
                  (gameStep.knockOut16 ? "active" : "inactive")
                }
              >
                OCTAVOS
              </span>
              <span
                className={
                  "rounded mx-1 px-3 py-2 shadow text-white btn-knockout-stage " +
                  (gameStep.knockOut8 ? "active" : "inactive")
                }
              >
                CUARTOS
              </span>
            </article>
            <article className="d-flex justify-content-center my-1 text-center">
              <span
                className={
                  "rounded mx-1 px-3 py-2 shadow text-white btn-knockout-stage " +
                  (gameStep.semiFinal ? "active" : "inactive")
                }
              >
                SEMIFINAL
              </span>
              <span
                className={
                  "rounded mx-1 px-3 py-2 shadow text-white btn-knockout-stage " +
                  (gameStep.final ? "active" : "inactive")
                }
              >
                FINAL
              </span>
            </article>
          </section>
          <section className="row mt-4 justify-content-between px-0 mx-auto w-50">
            {knockoutMatches.map((knockoutMatch, index) => {
              if (
                gameStep.knockOut16 ||
                (gameStep.knockOut8 && index < 4) ||
                (gameStep.semiFinal && index < 2) ||
                (gameStep.final && index < 1)
              ) {
                return (
                  <div
                    key={`knockout_match` + index}
                    className="btn-group"
                    role="group"
                  >
                    {knockoutMatch.map((knockoutMatchTeam, idx) => {
                      return (
                        <section
                          key={`knock` + index + idx}
                          className={
                            "col-6 mx-0 mt-1 " +
                            (idx === 0 ? "ps-0 pe-1" : "ps-1 pe-0")
                          }
                        >
                          <button
                            type="button"
                            className={
                              "w-100 btn d-flex justify-content-between align-items-center p-1 p-md-2 " +
                              (knockoutMatchTeam.winner
                                ? "knockout-stage-selected-team"
                                : "knockout-stage-unselected-team")
                            }
                            onClick={() => {
                              setShowWarning(false);
                              dispatch(
                                setWinner({ matchIdx: index, teamIdx: idx })
                              );
                            }}
                          >
                            <article className="d-flex align-items-center">
                              <img
                                src={getFlagUrl(knockoutMatchTeam.nation)}
                                alt={knockoutMatchTeam.nation}
                              />
                              <span
                                className={
                                  "ms-1 team-name " +
                                  (knockoutMatchTeam.winner
                                    ? "text-selected"
                                    : "text-unselected")
                                }
                              >
                                {knockoutMatchTeam.nation}
                              </span>
                            </article>
                            <div className="text-end">
                              <img
                                alt="radio"
                                src={
                                  knockoutMatchTeam.winner
                                    ? selectedIcon
                                    : unSelectedIcon
                                }
                              />
                            </div>
                          </button>
                        </section>
                      );
                    })}
                  </div>
                );
              } else {
                return <></>;
              }
            })}
            {showWarning ? (
              <section className="col-12 mt-2 text-center">
                <span className="text-danger team-name">
                  Debes elegir un ganador por cada partido
                </span>
              </section>
            ) : (
              <></>
            )}
            <section className="col-12 d-flex justify-content-center my-4">
              <button
                className="btn btn-next text-white"
                type="button"
                onClick={() => nextStep()}
              >
                SIGUIENTE
              </button>
            </section>
          </section>
        </section>
      )}
    </>
  );
}

export default KnockOut;
